import { Role } from '../../../interfaces/account';

export enum ChannelType {
  CENTROCOMPENTENZA = 'CDC',
  CONFIDI = 'CONFIDI',
  SGR = 'SGR',
  ASSOCIAZIONI = 'ASSOCIAZIONI',
  MEDIATORI = 'MEDIATORI',
  SPV = 'SPV',
  SPF = 'SPF',
  CMC = 'CMC',
}

export const ROLERECORD: Record<ChannelType, Role[]> = {
  ASSOCIAZIONI: ['Back office', 'Responsabile', 'Addetto'],
  CDC: ['Amministratore', 'Back office', 'Coordinatore'],
  CONFIDI: [
    'Responsabile',
    'Addetto',
    'Analista',
    'Coordinatore',
    'Back office',
  ],
  MEDIATORI: ['Back office', 'Responsabile', 'Addetto'],
  SGR: ['Back office', 'Responsabile', 'Addetto'],
  SPV: ['Supervisore'],
  SPF: ['Perito'],
  CMC: [
    'Responsabile',
    'Addetto',
    'Analista',
    'Coordinatore',
    'Back office',
    'Risk Manager',
    'Amministratore Delegato',
  ],
};
